import { Group, Image, Paper, Text } from '@mantine/core';
export type AsideCommandItemProps = {
  imgUrl: string;
  command: string;
  description: string;
};
export const AsideCommandItem: React.FC<AsideCommandItemProps> = ({
  imgUrl,
  command,
  description
}) => {
  return <Paper radius={5} p={10} bg="var(--bg-400)">
      <Group>
        <Image src={imgUrl} alt="command" w={40} h={40} />
        <Group fz="xs" c="var(--text-dark)" gap={6}>
          <Text inherit fw={700}>
            {command}
          </Text>
          <Text inherit>{description}</Text>
        </Group>
      </Group>
    </Paper>;
};